export default __webpack_public_path__ + "static/media/6 - Место встречи.dde31468.jpg";